import { gql, useSubscription } from '@apollo/client';
import { useContext, useEffect } from 'react';
import { CompanyContext } from '../../context/CompanyContext';
import { forNotification } from '../Common/forNotification';
import { ProductTransactionFragments } from '../../graphql/productTransaction.graphql';
import { ProductTransaction } from '../../types/productTransaction';
import React from 'react';
import { productTransactionSlice } from '../../providers/ProductTransactionProvider';
import { useAppDispatch } from '../../ui/pages/store';

const productTransactionSubscription = gql`
  subscription productTransactionNotification($companyId: String!) {
    productTransactionNotification(companyId: $companyId) {
      companyId
      entities {
        ...ProductTransaction
      }
      topic
      date
    }
  }
  ${ProductTransactionFragments.productTransaction}
`;

export class ProductTransactionNotificationResponse extends forNotification<ProductTransaction>(
  'productTransactionNotification',
) {}

export default function ProductTransactionNotification({}) {
  const { currentCompany } = useContext(CompanyContext);
  const dispatch = useAppDispatch();

  if (!currentCompany) return null;

  const { data: productTransactionNotifaction } = useSubscription<ProductTransactionNotificationResponse>(
    productTransactionSubscription,
    {
      variables: { companyId: currentCompany.id },
    },
  );

  const handleProductTransactionNotification = (notification?: ProductTransactionNotificationResponse) => {
    if (!notification?.productTransactionNotification) return;
    const productTransactionNotification = notification.productTransactionNotification;

    switch (productTransactionNotification.topic) {
      case 'CREATE':
      case 'UPDATE':
        dispatch(productTransactionSlice.actions.add(productTransactionNotification.entities));
        break;
      case 'DELETE':
        dispatch(productTransactionSlice.actions.delete(productTransactionNotification.entities));
        break;
    }
  };

  useEffect(() => {
    handleProductTransactionNotification(productTransactionNotifaction);
  }, [productTransactionNotifaction]);

  return <></>;
}
